import { render, staticRenderFns } from "./AdminConfirmDialog.vue?vue&type=template&id=8a40457c&scoped=true"
import script from "./AdminConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AdminConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminConfirmDialog.vue?vue&type=style&index=0&id=8a40457c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a40457c",
  null
  
)

export default component.exports